import React, { PropTypes } from 'react';
import { Divider, FontIcon, IconButton, ListItem } from 'material-ui';
import Dropzone from '../../../extra/dropzone/dropzone';

const UploadFiles = props => {
  const {
    files,
    css,
    removeFile,
    updateFileList,
    forDL,
  } = props;
  return (
    <div>
      Please upload your rates and policies (cancellation, child, etc.) by attaching a file below.&nbsp;
      {
        forDL && (
          'We will send you updates to keep you informed of our progress in loading your rates.'
        )
      }
      <br/>
      <br/>
      {
        files.map((file, i) => (
          <div key={i}>
            <ListItem
              primaryText={file.name}
              rightIconButton={<IconButton
                iconClassName="tc-icon-delete2"
                iconStyle={{ color: '#e65100' }}
                onTouchTap={removeFile(i)}
              />}
            />
            <Divider/>
          </div>
        ))
      }
      <Dropzone
        className={`dropzone ${css.dropZone2}`}
        onDrop={updateFileList}
      >
        <FontIcon className="tc-icon-add" color="#bfbfbf" style={{ fontSize: '80px', marginRight: '16px' }} />
        Attach files by dragging & dropping or&nbsp;<span style={{ color: '#00b3cf', cursor: 'pointer' }}>selecting them</span>
      </Dropzone>
    </div>
  );
};
UploadFiles.propTypes = {
  files: PropTypes.array,
  css: PropTypes.object,
  removeFile: PropTypes.func,
  updateFileList: PropTypes.func,
  forDL: PropTypes.bool,
};
export default UploadFiles;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/wizards/upload-files.jsx